import CrossChainClause from './CrossChainClause'

export default CrossChainClause
